import React, { Suspense, lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppShell } from '../layout/AppShell.jsx';
import { LoadingPage } from '../components/LoadingPage.jsx';
import { ROUTES } from './routes.js';

const LoginPage = lazy(() => import('../pages/LoginPage.jsx'));
const DashboardPage = lazy(() => import('../pages/DashboardPage.jsx'));
const ActivePdvPage = lazy(() => import('../pages/pdv/ActivePdvPage.jsx'));
const MasterPdvPage = lazy(() => import('../pages/pdv/MasterPdvPage.jsx'));
const PdvDetailPage = lazy(() => import('../pages/pdv/PdvDetailPage.jsx'));
const MapPage = lazy(() => import('../pages/MapPage.jsx'));
const PlanningPage = lazy(() => import('../pages/planning/PlanningPage.jsx'));
const PlanningEditorPage = lazy(() => import('../pages/planning/PlanningEditorPage.jsx'));
const VisitsPage = lazy(() => import('../pages/visits/VisitsPage.jsx'));
const VisitEditorPage = lazy(() => import('../pages/visits/VisitEditorPage.jsx'));
const SalesPage = lazy(() => import('../pages/sales/SalesPage.jsx'));
const TpointSalesPage = lazy(() => import('../pages/sales/TpointSalesPage.jsx'));
const GrabGoSalesPage = lazy(() => import('../pages/sales/GrabGoSalesPage.jsx'));
const IssuesPage = lazy(() => import('../pages/issues/IssuesPage.jsx'));
const IssueEditorPage = lazy(() => import('../pages/issues/IssueEditorPage.jsx'));
const ReportsPage = lazy(() => import('../pages/ReportsPage.jsx'));
const UsersPage = lazy(() => import('../pages/admin/UsersPage.jsx'));
const ImportsPage = lazy(() => import('../pages/admin/ImportsPage.jsx'));
const AuditPage = lazy(() => import('../pages/admin/AuditPage.jsx'));
const AccountPage = lazy(() => import('../pages/AccountPage.jsx'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage.jsx'));

const suspense = (element) => <Suspense fallback={<LoadingPage />}>{element}</Suspense>;

export const router = createBrowserRouter([
  { path: ROUTES.login, element: suspense(<LoginPage />) },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to={ROUTES.dashboard} replace /> },
      { path: 'dashboard', element: suspense(<DashboardPage />) },
      { path: 'pdv/attivi', element: suspense(<ActivePdvPage />) },
      { path: 'pdv/attivi/:pv', element: suspense(<PdvDetailPage source="active" />) },
      { path: 'pdv/master', element: suspense(<MasterPdvPage />) },
      { path: 'pdv/master/:pv', element: suspense(<PdvDetailPage source="master" />) },
      { path: 'mappa', element: suspense(<MapPage />) },
      { path: 'planning', element: suspense(<PlanningPage />) },
      { path: 'planning/nuovo', element: suspense(<PlanningEditorPage mode="create" />) },
      { path: 'planning/:planningId', element: suspense(<PlanningEditorPage mode="detail" />) },
      { path: 'visite', element: suspense(<VisitsPage />) },
      { path: 'visite/nuova', element: suspense(<VisitEditorPage mode="create" />) },
      { path: 'visite/:visitId', element: suspense(<VisitEditorPage mode="detail" />) },
      { path: 'vendite', element: suspense(<SalesPage />) },
      { path: 'vendite/tpoint', element: suspense(<TpointSalesPage />) },
      { path: 'vendite/grab-go', element: suspense(<GrabGoSalesPage />) },
      { path: 'segnalazioni', element: suspense(<IssuesPage />) },
      { path: 'segnalazioni/nuova', element: suspense(<IssueEditorPage mode="create" />) },
      { path: 'segnalazioni/:issueId', element: suspense(<IssueEditorPage mode="detail" />) },
      { path: 'report', element: suspense(<ReportsPage />) },
      { path: 'amministrazione/utenti', element: suspense(<UsersPage />) },
      { path: 'amministrazione/import', element: suspense(<ImportsPage />) },
      { path: 'amministrazione/audit', element: suspense(<AuditPage />) },
      { path: 'account', element: suspense(<AccountPage />) },
      { path: '*', element: suspense(<NotFoundPage />) }
    ]
  }
]);
